export default __webpack_public_path__ + "static/static-asset-smartyLightText-4c403b3c4ea68a9ef9f696fbab3c1941.svg";